
// import React, { useState, useEffect, useCallback } from 'react';
// import '../styles/OKRTracker.css';

// const QuarterlyUpdate = () => {
//   const [activeTab, setActiveTab] = useState("ACM Presentation");
//   const [feedData, setFeedData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [selectedFile, setSelectedFile] = useState("");
//   const [viewerOpen, setViewerOpen] = useState(false);

//   const fetchFeed = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res = await fetch(`/gt-api/get_quarterly_media.php?type=${activeTab}`);
//       const data = await res.json();
//       if (data.success) {
//         setFeedData(data.data);
//       } else {
//         setFeedData([]);
//       }
//     } catch (err) {
//       console.error("Feed error:", err);
//     } finally {
//       setLoading(false);
//     }
//   }, [activeTab]);

//   useEffect(() => {
//     fetchFeed();
//   }, [fetchFeed]);

//   const handleView = () => {
//     if (selectedFile) setViewerOpen(true);
//   };

//   const renderViewer = () => {
//     const fileExt = selectedFile.split('.').pop().toLowerCase();
//     const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileExt);
//     const isPDF = fileExt === 'pdf';

//     if (isImage) {
//       return (
//         <img
//           src={selectedFile}
//           alt="preview"
//           style={{
//             width: '100%',
//             height: '100%',
//             objectFit: 'contain',
//             pointerEvents: 'none',
//             userSelect: 'none'
//           }}
//           draggable={false}
//         />
//       );
//     }

//     if (isPDF) {
//       return (
//         <iframe
//           src={`${selectedFile}#toolbar=0`}
//           width="100%"
//           height="100%"
//           style={{
//             border: "none",
//             background: "#fff"
//           }}
//           className="qt-pdf-frame"
//         />
//       );
//     }

//     if (selectedFile.includes('localhost')) {
//       return (
//         <div style={{ color: '#fff', textAlign: 'center', padding: '100px 20px' }}>
//           <h3 style={{ color: '#ff4d4f' }}>Preview Not Available</h3>
//           <p style={{ opacity: 0.8 }}>
//             This file cannot be previewed here.
//           </p>
//           <p style={{ fontSize: '0.9rem', opacity: 0.6 }}>
//             Please contact management for access.
//           </p>
//         </div>
//       );
//     }

//     return (
//       <iframe
//         src={`https://docs.google.com/gview?url=${selectedFile}&embedded=true`}
//         width="100%"
//         height="100%"
//         frameBorder="0"
//         title="Viewer"
//         sandbox="allow-scripts allow-same-origin"
//         className="qt-iframe-viewer"  // 🔥 renamed
//       ></iframe>
//     );
//   };

//   return (
//     <div
//       className="okr-genesis-container animate-fade"
//       style={{ maxWidth: '1000px', margin: '0 auto', padding: '20px' }}
//     >
//       <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%' }}>

//         <div style={{ marginBottom: '10px' }}>
//           <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem', margin: 0 }}>
//             {activeTab}
//           </h2>
//           <div style={{ height: '2px', width: '50px', background: '#4facfe', marginTop: '8px' }}></div>
//         </div>

//         {!viewerOpen ? (
//           <div
//             className="okr-glass-card"
//             style={{
//               padding: '30px',
//               background: 'rgba(255, 255, 255, 0.03)',
//               borderRadius: '16px',
//               border: '1px solid rgba(255, 255, 255, 0.1)',
//               display: 'flex',
//               flexDirection: 'column',
//               alignItems: 'center',
//               gap: '20px'
//             }}
//           >
//             <div style={{ width: '100%', maxWidth: '500px' }}>
//               <label style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.8rem', marginBottom: '8px', display: 'block' }}>
//                 Select File
//               </label>
//               <select
//                 value={selectedFile}
//                 onChange={(e) => setSelectedFile(e.target.value)}
//                 style={{
//                   width: '100%',
//                   padding: '12px',
//                   background: 'rgba(0, 0, 0, 0.3)',
//                   color: '#fff',
//                   border: '1px solid rgba(255,255,255,0.2)',
//                   borderRadius: '8px'
//                 }}
//               >
//                 <option value="">-- Choose a File --</option>
//                 {feedData.map((item, index) => (
//                   <option key={index} value={`/gt-api/${item.file_path}`}>
//                     {item.title}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <button
//               onClick={handleView}
//               disabled={!selectedFile}
//               style={{
//                 padding: '12px 40px',
//                 borderRadius: '8px',
//                 fontWeight: '700',
//                 border: 'none',
//                 background: selectedFile
//                   ? 'linear-gradient(135deg, #0d68f0 0%, #1c88e6 100%)'
//                   : '#3171e9',
//                 cursor: 'pointer'
//               }}
//             >
//               VIEW FILE
//             </button>
//           </div>
//         ) : (
//           <div className="animate-fade" style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>

//             <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
//               <button
//                 onClick={() => setViewerOpen(false)}
//                 style={{
//                   background: 'rgba(255, 59, 48, 0.1)',
//                   color: '#ff3b30',
//                   border: '1px solid rgba(255, 59, 48, 0.3)',
//                   padding: '8px 20px',
//                   borderRadius: '6px',
//                   cursor: 'pointer'
//                 }}
//               >
//                 CLOSE PREVIEW
//               </button>
//             </div>

//             {/* 🔒 MAIN VIEWER */}
//             <div
//               className="okr-glass-card qt-viewer-container"  // 🔥 renamed
//               onContextMenu={(e) => e.preventDefault()}
//               style={{
//                 height: '75vh',
//                 borderRadius: '12px',
//                 overflow: 'hidden'
//               }}
//             >
//               {renderViewer()}
//             </div>

//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default QuarterlyUpdate;




















import React, { useState, useEffect, useCallback } from 'react';
import '../styles/OKRTracker.css';

const QuarterlyUpdate = () => {
  const [activeTab, setActiveTab] = useState("ACM Presentation");
  const [feedData, setFeedData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const [viewerOpen, setViewerOpen] = useState(false);

  const fetchFeed = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(
        `/gt-api/get_quarterly_media.php?type=${activeTab}`,
        {
          credentials: "include"
        }
      );
      const data = await res.json();
      if (data.success) {
        setFeedData(data.data);
      } else {
        setFeedData([]);
      }
    } catch (err) {
      console.error("Feed error:", err);
    } finally {
      setLoading(false);
    }
  }, [activeTab]);

  useEffect(() => {
    fetchFeed();
  }, [fetchFeed]);

  const handleView = () => {
    if (selectedFile) setViewerOpen(true);
  };

  const renderViewer = () => {
    const fileExt = selectedFile.split('.').pop().toLowerCase();
    const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileExt);
    const isPDF = fileExt === 'pdf';

    if (isImage) {
      return (
        <img
          src={selectedFile}
          alt="preview"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            pointerEvents: 'none',
            userSelect: 'none'
          }}
          draggable={false}
        />
      );
    }

    if (isPDF) {
      return (
        <iframe
          src={`${selectedFile}#toolbar=0`}
          width="100%"
          height="100%"
          style={{
            border: "none",
            background: "#fff"
          }}
          className="qt-pdf-frame"
        />
      );
    }

   

    return (
      <iframe
        src={`https://docs.google.com/gview?url=${selectedFile}&embedded=true`}
        width="100%"
        height="100%"
        frameBorder="0"
        title="Viewer"
        sandbox="allow-scripts allow-same-origin"
        className="qt-iframe-viewer"  // 🔥 renamed
      ></iframe>
    );
  };

  return (
    <div
      className="okr-genesis-container animate-fade"
      style={{ maxWidth: '1000px', margin: '0 auto', padding: '20px' }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%' }}>

        <div style={{ marginBottom: '10px' }}>
          <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem', margin: 0 }}>
            {activeTab}
          </h2>
          <div style={{ height: '2px', width: '50px', background: '#4facfe', marginTop: '8px' }}></div>
        </div>

        {!viewerOpen ? (
          <div
            className="okr-glass-card"
            style={{
              padding: '30px',
              background: 'rgba(255, 255, 255, 0.03)',
              borderRadius: '16px',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '20px'
            }}
          >
            <div style={{ width: '100%', maxWidth: '500px' }}>
              <label style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.8rem', marginBottom: '8px', display: 'block' }}>
                Select File
              </label>
              <select
                value={selectedFile}
                onChange={(e) => setSelectedFile(e.target.value)}
                style={{
                  width: '100%',
                  padding: '12px',
                  background: 'rgba(0, 0, 0, 0.3)',
                  color: '#fff',
                  border: '1px solid rgba(255,255,255,0.2)',
                  borderRadius: '8px'
                }}
              >
                <option value="">-- Choose a File --</option>
                {feedData.map((item, index) => (
                  <option key={index} value={`/gt-api/${item.file_path}`}>
                    {item.title}
                  </option>
                ))}
              </select>
            </div>

            <button
              onClick={handleView}
              disabled={!selectedFile}
              style={{
                padding: '12px 40px',
                borderRadius: '8px',
                fontWeight: '700',
                border: 'none',
                background: selectedFile
                  ? 'linear-gradient(135deg, #0d68f0 0%, #1c88e6 100%)'
                  : '#3171e9',
                cursor: 'pointer'
              }}
            >
              VIEW FILE
            </button>
          </div>
        ) : (
          <div className="animate-fade" style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button
                onClick={() => setViewerOpen(false)}
                style={{
                  background: 'rgba(255, 59, 48, 0.1)',
                  color: '#ff3b30',
                  border: '1px solid rgba(255, 59, 48, 0.3)',
                  padding: '8px 20px',
                  borderRadius: '6px',
                  cursor: 'pointer'
                }}
              >
                CLOSE PREVIEW
              </button>
            </div>

            {/* 🔒 MAIN VIEWER */}
            <div
              className="okr-glass-card qt-viewer-container"  // 🔥 renamed
              onContextMenu={(e) => e.preventDefault()}
              style={{
                height: '75vh',
                borderRadius: '12px',
                overflow: 'hidden'
              }}
            >
              {renderViewer()}
            </div>

          </div>
        )}
      </div>
    </div>
  );
};

export default QuarterlyUpdate;























